import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'mobx-react'
import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import ru from 'moment/locale/ru'
import momentTz from 'moment-timezone'

import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import Store from './Store/Store'
import { queryClient } from './api/react-query/api'
import { AppConfig } from './AppConfig'
import env from './env.json'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { isProd } from './helper'
import { Helmet } from 'react-helmet'

momentTz.updateLocale('ru', ru)
momentTz.locale('ru')
momentTz.tz.setDefault('Europe/Moscow')

if (env.envName !== AppConfig.env.development) {
  Sentry.init({
    dsn: env.sentryDSN,
    environment: env.envName,
    release: env.sentryReleaseName,
    sampleRate: 1,
    tracesSampleRate: 1,
    attachStacktrace: true,
    integrations: [new Integrations.BrowserTracing()]
  })
}

const store = new Store()

ReactDOM.render(
  <Sentry.ErrorBoundary fallback='Извините, что-то пошло не так :('>
    {!isProd() && (
      <Helmet>
        <meta name='robots' content='noindex, nofollow' />
      </Helmet>
    )}
    <QueryClientProvider client={queryClient}>
      <React.StrictMode>
        <BrowserRouter>
          <Provider {...store}>
            <App />
          </Provider>
        </BrowserRouter>
      </React.StrictMode>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
